var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUtilizationLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_29228_2713)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6609 4.33045L9.28696 11.6C8.9913 12.3478 8.46957 12.7826 7.89565 12.7826C7.42609 12.7826 7.02609 12.5391 6.8 12.1565C6.55652 11.7044 6.57391 11.1478 6.86957 10.6783L11.287 3.60001C11.513 3.25218 11.9652 3.13045 12.3304 3.32175C12.6957 3.51305 12.8348 3.94784 12.6609 4.33045ZM13.8435 6.43479C13.5826 6.15653 13.1478 6.13914 12.8522 6.40001C12.5739 6.66088 12.5565 7.09566 12.8174 7.39131C13.9652 8.64349 14.6087 10.2783 14.6087 12C14.6087 12.3826 14.9217 12.6957 15.3043 12.6957C15.687 12.6957 16 12.3826 16 12C16 9.93044 15.2348 7.94784 13.8435 6.43479ZM8.55652 5.28697C8.93913 5.32175 9.26956 5.04349 9.30435 4.66088C9.33913 4.27827 9.06087 3.94784 8.67826 3.91305C8.45217 3.89566 8.22609 3.87827 8 3.87827C3.58261 3.87827 0 7.53044 0 12.0174C0 12.4 0.313043 12.7131 0.695652 12.7131C1.07826 12.7131 1.3913 12.4 1.3913 12.0174C1.3913 8.29566 4.34783 5.26958 8 5.26958C8.1913 5.25218 8.38261 5.26958 8.55652 5.28697Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_29228_2713"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUtilizationLogo);
export default __webpack_public_path__ + "static/media/utilizationLogo.4178ceb42803f5a590640aee86d07a90.svg";
export { ForwardRef as ReactComponent };